module.exports = __webpack_public_path__ + "media/metronic/_theme/media/bg/sc-home1-bg-50587c184b9360f3ffad895ae5c90518.png";